import React, { createContext, useState } from "react";

// Create the context
const ArrayContext = createContext();

// Create a provider component
const ArrayProvider = ({ children }) => {
  // Set initial state
  const [navbarArray, setNavbarArray] = useState(null);
  const [footerArray, setFooterArray] = useState(null);
  const [categoriesArray, setCategoriesArray] = useState(null);
  const [socialArray, setSocialArray] = useState(null);
  const [footerPage, setFooterPage] = useState(null);
  const [footerSettings, setFooterSettings] = useState(null);
  const [footerData, setFooterData] = useState(null);
  const [callToAction, setCallToAction] = useState(null);

  // Context value object
  const contextValue = {
    navbarArray,
    setNavbarArray,
    footerArray,
    setFooterArray,
    categoriesArray,
    setCategoriesArray,
    socialArray,
    setSocialArray,
    footerPage,
    setFooterPage,
    footerSettings,
    setFooterSettings,
    footerData,
    setFooterData,
    callToAction,
    setCallToAction,
  };

  return (
    <ArrayContext.Provider value={contextValue}>
      {children}
    </ArrayContext.Provider>
  );
};

export { ArrayContext, ArrayProvider };
